/** Locale-aware title compare for Documentation template lists. */
export function compareTemplateTitles(a: string, b: string): number {
  return a.localeCompare(b, undefined, { sensitivity: 'base' });
}

export function sortByTemplateTitle<T extends { title?: string | null }>(
  items: readonly T[],
  order: 'asc' | 'desc' = 'asc',
): T[] {
  const dir = order === 'desc' ? -1 : 1;
  return [...items].sort((a, b) => dir * compareTemplateTitles(a.title ?? '', b.title ?? ''));
}

/**
 * Bulk status toggle: if the clicked row is selected, apply the new status to
 * every selected template. Otherwise only the clicked row changes.
 */
export function templateIdsForStatusToggle(
  clickedId: string,
  selectedIds: readonly string[],
): string[] {
  if (selectedIds.includes(clickedId)) {
    return [...selectedIds];
  }
  return [clickedId];
}
